import React from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG } from '../../../_metronic/helpers'
import { useLayout } from '../../../_metronic/layout/core'
import { andRoles, Role, useUserInfo } from '../../../utils/keycloak'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  exact?: boolean
  requiredRole?: Role
}

const AsideMenuItem: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  exact = false,
  requiredRole = andRoles(),
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to, exact)
  const { config } = useLayout()
  const { aside } = config
  const userInfo = useUserInfo()
  if (!requiredRole.hasRole(userInfo)) {
    return <></>
  }

  return (
    <div className="menu-item">
      <Link className={clsx('menu-link without-sub', { active: isActive })} to={to}>
        {hasBullet ? (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        ) : (
          <span className="menu-icon">
            {icon && aside.menuIcon === 'svg' && <KTSVG path={icon} className="svg-icon-2" />}
            {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-5 fa-fw me-3', fontIcon)}></i>}
          </span>
        )}
        <span className="menu-title">{title}</span>
      </Link>
      {children}
    </div>
  )
}

export { AsideMenuItem }
